import { render, staticRenderFns } from "./oldQhOders.vue?vue&type=template&id=129da048&"
import script from "./oldQhOders.vue?vue&type=script&lang=ts&"
export * from "./oldQhOders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports